/**
 * @param {String} url
 * @param {Function?} req
 * @param {Function?} onload
 */
function loadCss(url, req, onload) {
    // Если нужный стиль уже есть на странице, то не добавляем его снова
    var links = document.getElementsByTagName('link');
    for (var i = 0, l = links.length; i < l; i++){
        if (links[i].getAttribute('href') === url) {
        	if (onload) {
        		onload(links[i]);
            }
            return;
        }
    }

    var style = document.createElement('link');
    style.rel = 'stylesheet';
    style.type = 'text/css';
    style.href = url;

    if (onload) {
	        style.addEventListener('load', function () {
	            onload(url);
	        });

	        style.addEventListener('error', function (err) {
	        	  onload.error(err);
	        });
    }

    /** @type {HTMLElement} */
    var head = document.head || document.getElementsByTagName('head')[0];

    head.appendChild(style);
}

/**
 * Добавляем CSS к <head>
 * @param {HTMLElement} element
 */
function activate(element) {
    var
        /** @type {string} */
        url = element.getAttribute('data-url');

    if (url) {
    	loadCss(url);
    }

}

export default { load: loadCss, activate };

export { loadCss as load, activate };
